var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73557 20.048H5.84134C5.08777 20.048 4.36506 19.7487 3.83221 19.2158C3.29935 18.683 3 17.9603 3 17.2067V16.2596H8.20913M16.2596 8.20913V4.89423C16.2596 4.51959 16.3707 4.15336 16.5788 3.84185C16.787 3.53035 17.0828 3.28756 17.4289 3.14419C17.7751 3.00082 18.1559 2.96331 18.5234 3.0364C18.8908 3.10949 19.2283 3.28989 19.4932 3.55481C19.7582 3.81972 19.9386 4.15724 20.0117 4.52468C20.0847 4.89213 20.0472 5.27299 19.9039 5.61912C19.7605 5.96524 19.5177 6.26108 19.2062 6.46922C18.8947 6.67736 18.5285 6.78846 18.1538 6.78846H16.2596M18.1538 3H7.73557C6.982 3 6.25929 3.29935 5.72644 3.83221C5.19358 4.36506 4.89423 5.08777 4.89423 5.84134V16.2596M8.68268 6.78846H12.4711M8.68268 10.5769H12.4711M17.6045 12.1018C17.9775 11.7287 18.4834 11.5192 19.011 11.5192C19.5385 11.5192 20.0444 11.7287 20.4174 12.1018C20.7904 12.4748 21 12.9807 21 13.5082C21 14.0358 20.7904 14.5417 20.4174 14.9147L14.3654 20.9952H11.524V18.1538L17.6045 12.1018Z",
    stroke: "#192048",
    strokeWidth: 1.51538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule5);
export default __webpack_public_path__ + "static/media/CustomModule5.493d54b8ffb97336bdab5114f9a76d20.svg";
export { ForwardRef as ReactComponent };